import React from 'react'

import { useRoute } from '@react-navigation/native'
import { Stack } from '@zet/design-system/layout'

import { Header } from './modules/header'
import { LoadingScreen } from './modules/loadingScreen'
import { UserDetailsProps } from './types'
import { isPLHLPartner } from './utils/plhlPartnerIds'
import { stateMap } from './utils/stateMap'

interface Props {
  applicationDetails: {
    partnerId: number
    customerId: number
    onecode: string
    brandLogoUrl: string
    leadSource?: string
    bankName: string
    metadata?: {
      partnerPrimaryColor?: string
      applicationType?: string
    }
  }
}

const BrandScreens = (props: Props) => {
  const {
    applicationDetails: {
      partnerId,
      brandLogoUrl,
      metadata,
      customerId,
      onecode,
      leadSource,
    },
  } = props

  const { params = {} } = useRoute()

  const { state } = params

  const _stateMap = stateMap[String(partnerId)]

  const userDetails: UserDetailsProps = {
    partnerId,
    customerId,
    onecode,
    leadSource,
  }

  const { Component = LoadingScreen, props: _props = {} } =
    _stateMap?.[state || 'CC_START'] || {}

  return (
    <Stack className="flex-1 bg-white">
      {isPLHLPartner({ partnerId }) ? null : (
        <Header
          logoUrl={brandLogoUrl}
          partnerId={partnerId}
          metadata={metadata}
        />
      )}
      <Component state={state} userDetails={userDetails} props={_props} />
    </Stack>
  )
}

export default BrandScreens
